/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FC } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  flexRender,
  type Header,
} from "@tanstack/react-table";
import { OrderListingType } from "types/order";
import { TableCell } from "@mui/material";

type Props = {
  header: Header<OrderListingType, unknown>
}

export const OrderTableColumn: FC<Props> = ({ header }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: header.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    borderBottom: "none",
    fontSize: "0.875rem",
    cursor: "grab"
  };

  return (
    <TableCell
      className="users-table-cell"
      style={style}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <div
        className={header.column.getCanSort()
          ? "cursor-pointer select-none"
          : ""}
        onClick={header.column.getToggleSortingHandler()}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
      </div>
    </TableCell>
  );
};
